import { eciToGeodetic, gstime, propagate } from 'satellite.js';
import type { ElementRecord } from '../../../../worker/catalogue/history';
import { parseOrbitalInput } from './orbit';
import { solutionFingerprint } from './quality';
import { relativeFrame } from './geometry';

export function historyDiagnostics(records:ElementRecord[]) {
  const seen=new Set<string>();
  const unique=[...records].sort((a,b)=>Date.parse(a.fetchedAt)-Date.parse(b.fetchedAt)).filter(r=>{const key=solutionFingerprint(r.object);if(seen.has(key))return false;seen.add(key);return true;});
  return unique.map((record,i)=>{
    const object=record.object,at=object.epochMs,date=new Date(at),rec=parseOrbitalInput({id:object.id,omm:object.omm}),pv=rec&&propagate(rec,date);
    const previous=unique[i-1],old=previous&&parseOrbitalInput({id:previous.object.id,omm:previous.object.omm}),oldPv=old&&propagate(old,date);
    const residualKm=pv&&oldPv?Math.hypot(pv.position.x-oldPv.position.x,pv.position.y-oldPv.position.y,pv.position.z-oldPv.position.z):null;
    const longitudeDeg=pv?eciToGeodetic(pv.position,gstime(date)).longitude*180/Math.PI:null;
    return {...record,longitudeDeg,residualKm,ricKm:pv&&oldPv?relativeFrame(oldPv,pv).ricKm:undefined,
      sameEpochCorrection:!!previous&&previous.object.epochMs===at,epochGapHours:previous?(at-previous.object.epochMs)/3600000:null};
  });
}
